export const hasAnchor = (link: string) => {
  return link?.at(0) === '#';
};
export const isExternalPage = (link: string) => {
  return link?.indexOf('http') === 0;
};
